export let Configuration = {

    addressService: {
        useGoogleAddress: true,
        useEsriAddress: false,
        saveAddressInCassandra: true
    },

    urls: {
        webApiEndpoint: "http://" + location.hostname + ":90",
        signalrCoreEndpoint: "http://" + location.hostname + ":93",
        jwtTokenEndPoint: "https://dcst.altair.ai:5002",
        SendOrders: 'http://localhost:53119/api/Order/SendOrders',
        DeleteOrder: 'http://localhost:53119/api/Order/DeleteOrder',
        RescheduleOrder: 'http://localhost:53119/api/Order/RescheduleOrder',
        //--------------Testing------------///////////////////
        //webApiEndpoint: "http://41.33.122.55" + ":90",
        //signalrCoreEndpoint: "http://41.33.122.55" + ":93",
   // signalrEndpoint: "http://41.33.122.55:91",
        //GetNormaCities: 'http://41.33.122.55:92/api/Zone/GetNormaCities',
        //GetNormaZones: 'http://41.33.122.55:92/api/Zone/GetNormaZones',


        //SendOrders: 'https://testservices.asknorma.ai:8088/api/Order/SendOrders',
        //DeleteOrder: 'https://testservices.asknorma.ai:8088/api/Order/DeleteOrder',
        //RescheduleOrder: 'https://testservices.asknorma.ai:8088/api/Order/RescheduleOrder',

        //------------Staging---------//////////
     //   webApiEndpoint: "https://staging.dc.altair.ai:5002/",
        signalrEndpoint: "https://staging.realtime.altair.ai/",
    //    signalrCoreEndpoint: "https://Staging.realtimecore.altair.ai:93",
        GetNormaCities: 'https://staging.mobile.altair.ai/api/Zone/GetNormaCities',
        GetNormaZones: 'https://staging.mobile.altair.ai/api/Zone/GetNormaZones',


        SendNormaLiveOrders: "http://" + location.hostname + ":2020/api/NormaLive/AddOrder",
        SendNormaLiveVehicle: "http://" + location.hostname + ":2020/api/NormaLive/AddVehicle",
        //GoogleMapDirectionUrl: 'http://maps.googleapis.com/maps/api/directions/json?',
        GoogleMapUrl: 'http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
        ESRIMapUrl: 'https://server.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
        OpenStreetMapUrl: 'https://a.tile.openstreetmap.org/${z}/${x}/${y}.png',
        ///////////////////////////////////////

        calculateRouteUrl: '/api/MapUtils/CalculateRoute',
        pictureById: '/api/Attachment/',

        lookup_AllUrl: '/api/Lookup/',
        lookup_Long: '/api/LookupLong/',
        lookup_Localization: 'Localization/',

        appConfigUrl: '/api/AppConfig/sub/',
        registerStaffOnInterestedVehicles: '/api/Vehicle/RegisiterCurrentStaffOnInterestedVehicles',
        registerStaffOnInterestedVehiclesForDisplay: '/api/Vehicle/RegisiterCurrentStaffOnInterestedVehiclesForDisplay',
        TrackedObjectIconURl: '/api/Vehicle/TrackedObjectIcon/',
        TrackedObjectIconMonitor: '/api/Vehicle/TrackedObjectIconMonitor/',
        GetRuleByVehicle: '/api/Rule/ruleByVehicle/',
        GetOrderTypes: '/api/order/GetOrderTypes',
        sysConfigUrl: '/api/AppConfig/',

        userPreferenceUrl: '/api/preference/',

        transporterHistoryUrl: '/api/transporter/history/',

        attachmentUrl: '/api/Attachment/',
        importUrl: '/api/ImportFile/',
        getImportTemplateUrl: '/api/ImportFile/GetTemplate/',
        poiUrl: '/api/POI/',
        filterPOIUrl: '/api/POI/Filter/',

        poiGetUrl: '/api/POI/POIViews/',
        poiFindUrl: '/api/POI/Find/',
        FindNearestUrl: '/api/POI/Nearest/',
        transporterPOI: '/api/Route/TransporterPOI/',
        branchPoiTypesUrl: '/api/POI/BranchPOITypes/',
        CheckPOILimitReached: '/api/POI/CheckLimitReached',
        GetPOIAttachments: '/api/POI/GetPOIAttachments/{0}',
        //Authentication API's
        tokenUrl: '/Token',
        accountApi: '/api/Account/',
        logoutUrl: '/api/Account/Logout',
        validateTokenUrl: '/api/Account/ValidateToken',
        saveUserUrl: '/api/Account/SaveUser/',
        resetPasswordUrl: '/api/Account/ResetPassword/',
        changePasswordUrl: '/api/Account/ChangePassword/',
        forgotPasswordUrl: '/api/Account/ForgotPassword/',
        validateResetPasswordUrl: '/api/Account/ValidateResetPasswordToken/',
        deleteUserUrl: '/api/Account/DeleteUser/',
        getUserDetailsUrl: '/api/Account/GetUserDetails/',
        staffApi: '/api/Staff/',
        GetManagerstaffApi: '/api/Staff/GetAllStaffManager/',
        filterStaffApi: '/api/Staff/Filter/',
        authorizeCntrls: '/api/Account/Authorize/Controls/',
        authorizeModules: '/api/Account/Authorize/Modules/',
        authorizePages: '/api/Account/Authorize/Pages/',
        userNotificationApi: '/api/User/Notifications',
        getDriverByBranchIdApi: '/api/staff/DriverByBranchId/',
        getStaffByRoleNameApi: '/api/Staff/staffbyrolename/driver',
        getStaffByReferenceNameApi: '/api/Staff/staffbyreferencename/',
        CheckUserLimitReached: '/api/Staff/CheckLimitReached',
        UpdateNotificationStatus: '/api/User/UpdateNotificationStatus/',
        UpdateAllNotificationStatus: '/api/User/UpdateAllNotificationStatus/',
        GetStaffWithRolesByBranchId: "/api/staff/GetStaffWithRolesByBranchId",
        getDriversByBranchId: "/api/staff/DriversByBranchId",
        //History
        routeSummaryUrl: '/api/History/RouteSummary',

        //Transporter
        saveTransporterUrl: '/api/Transporter/Save',
        TransporterUrl: '/api/Vehicle/',
        TransporterDetailsInfUrl: '/api/Vehicle/Inf/',
        VehicleIntegrationModelDetailsUrl: '/api/Vehicle/ExtraInf/',
        TransporterDetailsInfFromDisplayNameUrl: '/api/Vehicle/InfFromDisplayName/',
        TransporterStateUrl: '/api/Vehicle/state/',
        getTransporterFilter: '/api/Vehicle/Filter',
        unRegisterUserUrl: '/api/Vehicle/unRegisterUser/',
        removeVehicleUrl: '/api/Vehicle/Remove',
        TransporterUrlBatchInfoGet: '/api/Vehicle/Calibrations/',
        TransporterUrlSaveMileageCalibration: '/api/Vehicle/{0}/Mileage/{1}/',
        TransporterUrlSaveFuelCalibration: '/api/Vehicle/{0}/Fuel/{1}/',
        CurrentDriver: '/api/Staff/CurrentDriver/',
        VehicleCalibration: '/api/Vehicle/Calibrations/',
        VehicleVectors: '/api/Vehicle/VectorView',
        VehicleInf: 'WithInfluencer/Filter',
        InfluncedVehicleBasic: '/api/Vehicle/InfluencedVehicleBasicInfo',
        InfluncedWOVehicleBasic: '/api/Vehicle/InfluencedWOVehicleBasicInfo',
        InfluncedWOVehicleStaffBasic: '/api/Vehicle/InfluencedWOVehicleBasicInfoByDriverId',
        VehilceStaffReference: '/api/Staff/VehicleStaffReference',
        VehicleInfsubscriber: '/api/Vehicle/WithInfluencerbysubscriber/Filter',
        CheckVehicleLimitReached: '/api/Vehicle/CheckLimitReached',
        VehilceStaffReferenceInf: '/api/Staff/VehicleStaffReferenceInf',
        //Sensor
        sensorUrl: '/api/Vehicle/Sensor/',
        filterSensorUrl: '/api/Vehicle/Sensor/Filter',
        GetSensors: '/api/Sensor/GetSensors',
        GetSensorsWithVehicle: '/api/Sensor/GetSensorsWithVehicle',
        removeSenesorUrl: '/api/Vehicle/Sensor/Remove',
        saveCanbus: '/api/Sensor/SaveCanbus',
        deleteCanbus: '/api/Sensor/DeleteCanbus',

        // Routes
        routeUrl: '/api/Route',
        routePOIUrl: '/api/Route/',
        routePOIDeleteUrl: '/api/Route/DeleteRoutesPOI/',
        routePOIReorderUrl: '/api/Route/PostListRoutesPOI/',
        routeOnMapUrl: '/api/Route/GetBusRoutesOnMap',

        //Device
        DeviceUrl: '/api/Device/',
        DeviceFilterUrl: '/api/Device/Filter',
        unassignDevice: '/api/Vehicle/Release/{0}/device',
        ChangeAssign: '/api/Device/ChangeAssign/',
        Assign: '/api/Vehicle/Assign/{0}/Device/{1}',
        AssignedDeviceByVehicleId: '/api/Vehicle/assign/{0}/device',
        NotAssginedDevices: '/api/Device/NotAssgined',
        startDeviceLog: '/api/Device/StartLogging',
        endDeviceLog: '/api/Device/EndLogging',
        isCurrentStaffLogging: '/api/Device/IsCurrentStaffLogging',
        GetDeviceModelConfiguration: '/api/Device/DeviceConfiguration/',
        GetModelCanbusSensor: '/api/Device/ModelCanbusSensor',
        addDevice: '/Api/device/saveandassign',
        //Branch
        branchUrl: '/api/Branch/',
        branchesUrl: '/api/Branch/Filter/',
        brancheWithoutInfUrl: '/api/Branch/FilterWithoutInf/',
        branchesFilterUrl: '/api/Branch/FilterBy/',
        branchesCountUrl: '/api/Branch/BranchCount',
        branchesRootParentUrl: '/api/Branch/BranchesRootParent/',
        subBranchesUrl: '/api/Branch/ChildrenBranches/',
        AllSubBranchesUrl: '/api/Branch/AllChildrenBranches/',
        DirectSubBranchesUrl: '/api/Branch/DirectChildrenBranches/',
        VehicleByBranchUrl: '/api/Vehicle/Branchs',
        //branchGetAll: '/api/Branch/Branches',
        getBranchViewsUrl: '/api/Branch/BranchViews',
        getBranchNames: '/api/Branch/BranchNames',
        getInfluencedBranchPerStaff: '/api/Branch/InfluencedBranches',


        //Geofence
        GeofenceUrl: '/api/Geofence/',
        GeofenceFilterUrl: '/api/Geofence/Filter/',
        GeofenceFilterAllUrl: '/api/Geofence/FilterAll',
        GeofenceViewUrl: '/api/Geofence/GeofenceViews/',
        CheckGeofenceLimitReached: '/api/Geofence/CheckLimitReached',

        //Vehcle Associations
        VehicleAssociationUrl: '/api/VehicleAssociations/',

        //Rules
        GetRulesByPolicyId: '/api/Rule/GetByPid/',
        RulesUrl: '/api/Rule/',
        GetEventTypes: '/api/EventType',
        GetNotMonitor: '/api/EventType/NotMonitor',
        FilterEventTypes: '/api/EventType/GetAllEvents',

        // Polcies
        GetPoliciesByGeofenceId: '/api/policy/',
        GetDefaultPolicy: '/api/Policy/DefaultPolicy/',
        getStaffList: '/api/Policy/StaffList/',
        SavePolicy: '/api/Policy',
        SavePolicyGeofenceAssociation: '/api/Policy/GeofenceAssociation',
        SavePolicyStaffAssociation: '/api/Policy/PolicyStaffAssociation',
        DeletePolicy: '/api/Policy/',
        GetActiveTimeByPolicyID: '/api/policy/GetActiveTimeByPolicy/',
        SaveActiveTimeForPolicyID: '/api/policy/SaveActiveTimeForPolicy',
        //Organizations
        organizationUrl: '/api/organization/',
        orgStaff: 'Staff',
        getOrgnizationActions: 'GetOrgnizationActions/',
        saveActionsOnOrganizationChart: 'SaveActionsOnOrganizationChart',
        orgDeleteStaff: 'DeleteStaff',
        GetActionsByStaffId: 'Actions',
        //Students
        studentApi: '/api/Student/',
        retreiveStudetnsWithPaging: '/api/Student/all',
        subscriberParentUrl: '/api/staff/GetSubscriberParents/',
        getStudentDetailsUrl: '/api/Student/',
        saveStudentUrl: '/api/Student/Save',
        studentsByParentUrl: '/api/Student/StudentsByParent?parentId=',
        studentsByParentIdsUrl: '/api/Student/StudentsByParentIds',
        studentAttendanceById: '/api/Student/StudentAttendance/',
        //Branch
        branchApi: '/api/Branch/Filter/',

        // Planning Service
        LogisticsServiceSubmitJobURL: 'https://logistics.arcgis.com/arcgis/rest/services/World/VehicleRoutingProblem/GPServer/SolveVehicleRoutingProblem/submitJob?',
        LogisticsServiceOutputResultURl: 'https://logistics.arcgis.com/arcgis/rest/services/World/VehicleRoutingProblem/GPServer/SolveVehicleRoutingProblem/jobs/',

        //workorder List
        woApi: '/api/WO/',
        SchoolWorkOrderUrl: '/School/View',
        SchoolWorkOrderStudentsUrl: '/School/workOrderStudents',
        GetRouteId: '/api/plantransporterroute/',
        GetRoute: '/api/Route/',
        GetPOIHistory: '/api/WO/POILogs/',
        GetReverseWOList: '/api/WO/GetReverseWOList',
        getReverseWorkOrderOrderReturns: '/api/WO/getReverseWorkOrderOrderReturns/',
        confirmReceivingOrders: '/api/WO/confirmReceivingOrders',
        ExportWordOrderReceiving: '/api/WO/ExportWordOrderReceiving/',

        // Staff Perference List
        StaffPreference: "/api/User/Preference/",
        SavePreference: "/api/User/SavePreference",
        DeletePreference: "/api/User/DeletePreference",
        EventType: "/api/User/EventTypes/",
        EventTypeNotMonitor: "/api/User/EventTypesNotMonitor/",
        getStaffInf: "/api/staff/getStaffInf",

        // Panic Staff
        PanicStaff: "/api/PanicStaff",
        PanicStaffSave: "/api/PanicStaff/Save",
        CurrentStaffPanicRole: "/api/PanicStaff/Current",
        PanicResolve: '/api/PanicStaff/Resolve',
        PanicList: '/api/PanicStaff/Panics',
        // Static Reports / Detailed Reports
        Detailed_ActivityEventsDetails: "/api/StaticReports/DetailedReports/ActivityEventsDetails",
        Detailed_DriverViolationDetails: "/api/StaticReports/DetailedReports/DriverViolationDetails",
        Detailed_IdleTimeDetails: "/api/StaticReports/DetailedReports/IdleTimeDetails",
        Detailed_MovingTimeDetails: "/api/StaticReports/DetailedReports/MovingTimeDetails",
        Detailed_ParkingTimeDetails: "/api/StaticReports/DetailedReports/ParkingTimeDetails",
        Detailed_SpeedViolationDetails: "/api/StaticReports/DetailedReports/SpeedViolationDetails",
        Detailed_ViolationDetails: "/api/StaticReports/DetailedReports/ViolationDetails",

        // Static Reports / Notification Reports
        Notification_Notifications: "/api/StaticReports/Notification/Notifications",
        Notification_SensorEvents: "/api/StaticReports/Notification/SensorEvents",
        Notification_Panic: "/api/StaticReports/Notification/Panic",

        // Static Reports / Utilization Reports
        Utilization_ActiveTime: "/api/StaticReports/Utilization/ActiveTime",
        Utilization_ActivityDetails: "/api/StaticReports/Utilization/ActivityDetails",
        Utilization_DailySpeed: "/api/StaticReports/Utilization/DailySpeed",
        Utilization_DailyTripSummary: "/api/StaticReports/Utilization/DailyTripSummary",
        Utilization_MovementActivity: "/api/StaticReports/Utilization/MovementActivity",
        Utilization_MovingDetails: "/api/StaticReports/Utilization/MovingDetails",
        Utilization_ParkingTimes: "/api/StaticReports/Utilization/ParkingTimes",
        Utilization_VehicleDailyUsage: "/api/StaticReports/Utilization/VehicleDailyUsage",
        Utilization_VehicleGeofenceDetails: "/api/StaticReports/Utilization/VehicleGeofenceDetails",
        Utilization_VehicleOverview: "/api/StaticReports/Utilization/VehicleOverview",
        Utilization_VehicleSummaryUsage: "/api/StaticReports/Utilization/VehicleSummaryUsage",
        Utilization_VisitedPlacesSummary: "/api/StaticReports/Utilization/VisitedPlacesSummary",
        Utilization_DailyDriverSummary: "/api/StaticReports/Utilization/DailyDriverSummary",

        // Static Reports / Violation Reports
        Violation_DailyViolationSummary: "/api/StaticReports/Violation/DailyViolationSummary",
        Violation_DriverDailyUsage: "/api/StaticReports/Violation/DriverDailyUsage",
        Violation_DriverViolation: "/api/StaticReports/Violation/DriverViolation",
        Violation_GreenDriver: "/api/StaticReports/Violation/GreenDriver",
        Violation_SpeedViolation: "/api/StaticReports/Violation/SpeedViolation",
        Violation_ViolationDetailsViews: "/api/StaticReports/Violation/ViolationDetailsViews",
        IbuttonLog: "/api/StaticReports/Sensor/IbuttonLog",
        RFIDLog: "/api/StaticReports/Sensor/RFIDLog",
        // Dashboard Controllers
        DashboardsController: '/api/dashboard',
        MovementDashboard_Cards: '/Movement/Cards',
        MovementDashboard_DistanceSpeedPerVehicleType: '/Movement/DistanceSpeedVehicleType',
        MovementDashboard_DistanceSpeedOverTime: '/Movement/DistanceSpeedPerTime',
        MovementDashboard_EventsOverTime: '/Movement/EventsPerTime',
        MovementDashboard_DayNightDistanceDuration: '/Movement/DayNightDistanceDuration',

        DriverScoreCards: '/driver/Cards',
        DriverScoreNumberOfEvents: '/driver/numberofevents',
        DriverEventScorePerTime: '/driver/EventScorePerTime',
        DriverScoreMatrix: '/driver/DriverScoreMatrix',
        DriverTotalScorePerTime: '/driver/TotalScorePerTime',
        DriverBasicInfo: '/driver/DriverBasicInfo',

        FleetDashboard_Cards: '/Fleet/Cards',
        FleetDashboard_BranchFleet: '/Fleet/FleetByBranch',
        FleetDashboard_VehicleTypeFleet: '/Fleet/FleetByVehicleType',
        FleetDashboard_VehicleManufactureFleet: '/Fleet/FleetByManufacture',
        FleetDashboard_VehicleModelFleet: '/Fleet/FleetByModel',
        FleetDashboard_VehicleOperatorFleet: '/Fleet/FleetByOperator',
        FleetDashboard_VehicleDeviceModelFleet: '/Fleet/FleetByDeviceModel',

        //WorkOrderDashboard Controller
        WorkOrderDashboardsController: '/api/WODashboard',
        GetOrderByBranch: '/GetOrderByBranch',
        GetOrderByDriver: '/GetOrderByDriver',
        GetOrderByZone: '/GetOrderByZone',
        GetSLAComplianceByBranch: '/GetSLA',
        GetSLAComplianceByOrder: '/GetSLAByOrder',
        SLATrendPerBranch: '/SLATrendPerBranch',
        OnTimeShippingByBranch: '/OnTimeShippingByBranch',
        /////Influencer 
        assignStaffToInfluencedBranch: '/api/Staff/AssignInfluencedBranch',
        RemoveInfluencedBranch: '/api/Staff/RemoveInfluencedBranch',

        ////Cassandra
        SaveAddress: '/api/Cassandra/SaveAddress',
        GetAddress: '/api/Cassandra/Address',
        GetEsriAddress: '/api/Cassandra/GetEsriAddress',

        googleMapApi: 'https://maps.googleapis.com/maps/api/js?v=3&key=',
        esriJavaScriptApi: '/Scripts/esriScripts',


        ///// Driver Card Settings
        PerformanceMatrix: '/api/driverscoresettings/getperformancematrix',
        SavePerformanceMatrix: '/api/driverscoresettings/saveperformancematrix',
        SavePerformancePoints: '/api/driverscoresettings/saveperformancepoints',
        PerformanceIndex: '/api/driverscoresettings/getperformanceindex',
        SavePerformanceIndex: '/api/driverscoresettings/saveperformanceindex',
        ConfigurationKeys: '/api/driverscoresettings/DriverKeys',
        SaveConfigurationKeys: '/api/driverscoresettings/SaveDriverKeys',

        //History
        historyUrl: '/api/History/',
        historyConfigurationUrl: '/api/History/Configuration',
        eventUrl: '/api/EventsLog/',

        //Product
        FilterProduct: '/api/NormaProduct/FilterProducts',
        UpdateProductStatus: '/api/NormaProduct/UpdateProductStatus',

        /////////// Norma Vehicle
        // NormaVehicleTypeUrl: '/api/NormaVehicleType/',


        // Norma Customer
        NormaCustomerFilter: "/api/NormaCustomer/Filter",
        NormaCustomerFilterInf: "/api/NormaCustomer/FilterInf",
        GetAllocatedCustomersInf: "/api/NormaCustomer/GetAllocatedCustomersInf",

        // Operational Reports
        customerServiceTimeReport: "/api/WOReports/Service/CustomerServiceTime",
        servingTimeTrendReport: "/api/WOReports/Service/ServingTimeTrend",

        getLateStart: "/api/WOReports/Violation/LateStart",
        getWorderOrderAlertsReport: "/api/WOReports/Violation/Alerts",

        getFleetUtilization: "/api/WOReports/Utilization/FleetUtilization",

        getFailsToDeliver: "/api/WOReports/Deviation/FailToDeliver",
        getTimeDeviationReport: '/api/WOReports/Deviation/TimeDeviation',

        getWorkOrderStatusReport: "/api/WOReports/Status/WOStatus",
        getDeliveriesStatusReport: "/api/WOReports/Status/DeliveryStatus",

        getDailyWODetailsReport: "/api/WOReports/Daily/WODetails",
        getLateStartDetailsReport: "/api/WOReports/Daily/LateDetails",
        getBranchPerformance: "/api/WOReports/NormaOrder/BranchPerformance",
        getZonePerformance: "/api/WOReports/NormaOrder/ZonePerformance",
        getSLAReport: "/api/WOReports/NormaOrder/OrdersCompliance",
        getOrdersDetais: "/api/WOReports/NormaOrder/details",
        getOrderRawData: "/api/WOReports/NormaOrder/OrderRawData",
        getOrderSummaryData: "/api/WOReports/NormaOrder/OrderSummaryData",

        //Administraion Reports
        getAdminAllVehicles: "/api/Administration/GetAllVehicles",
        getAdminAllDevices: "/api/Administration/GetAllDevices",
        getAdminAllSubscribers: "/api/Administration/GetAllSubscribers",
        getDeviceList: '/api/Administration/GetDeviceList',


        getUsersBySubscriber: '/api/Administration/GetUsersBySubscriber',
        getStaffBySubscriber: '/api/Administration/GetStaffBySubscriber',
        getPOILocal: "/api/Administration/POILocal",
        getGeofenceBySubscriber: '/api/Administration/GetGeofenceBySubscriber',
        getDeviceCodeBySubscriber: "/api/Administration/GetAllDevices",

        // Subscriber
        GetAllSubscriber: "/api/Subscriber/GetAllSubscriber",
        GetSubscriberConfigurations: "/api/Subscriber/GetConfigurations",

        //ReportLog
        vehiclereportlog: "/api/reportlog/vehiclelog",
        filterStaffLog: "/api/reportlog/stafflog",
        filterVehicleSummary: "/api/reportlog/vehicleSummary",
        getPOIReport: "/api/reportlog/poilog",
        getGeofenceReport: "/api/reportlog/geofencelog",
        getFirstSignalReportData: "/api/reportlog/GetFirstSignalReportsData",
        getSubscriberSummaryReportData: "/api/reportlog/GetSubscriberSummaryReportsData",
        getVehicleSummaryReportData: "/api/reportlog/GetVehicleSummaryReportsData",
        getUserSummaryReportData: "/api/reportlog/GetUserSummaryReportsData",
        getGPSDisconnected: "/api/reportlog/getGPSDisconnected",
        getAuditLogReport: "/api/reportlog/getAuditLogReport",

        //subscriber users
        getSubscriberUsers: "/api/Staff/getSubscriberUsers",
        updateUsersLocking: "/api/Staff/updateUsersLocking",

        // Maintenance
        GetRepairRequestList: "/api/Maintenance/GetRepairRequestList",
        getPMPList: "/api/Maintenance/GetPMPList",
        GetAllVehiclesByBranchs: "/api/Maintenance/GetAllVehiclesByBranchs",
        SavePMP: "/api/Maintenance/SavePMP",
        GETPMP: "/api/Maintenance/GetPMP/",
        GetAllStaffByBranchs: "/api/Maintenance/GetAllStaffByBranchs",
        GetMWO: "/api/Maintenance/GetMWO",
        GetMWOById: "/api/Maintenance/GetMWOById/",
        SaveMWO: "/api/Maintenance/SaveMWO",
        DeAssignedRepairs: "/api/Maintenance/DeAssignedRepairs",
        GetPOINameByType: "/api/Administration/POIType",
        SaveRFR: "/api/Maintenance/SaveRFR",
        GetRFR: "/api/Maintenance/GetRFR/",
        GetRepairRequest: "/api/Maintenance/GetRepairRequest",
        EditRepairRequest: "/api/Maintenance/EditRepairRequest",
        GetWorkOrderOfRepairRequestList: "/api/Maintenance/GetWorkOrderOfRepairRequestList/",

        // Nearest by 

        NearestVehicle: "/api/Vehicle/NearestVehicle",
        NearestPOI: "/api/POI/NearestPOI",
        NearestBranch: "/api/Branch/NearestBranch",
        NearestGeofence: "/api/Geofence/NearestGeofence",

        getSensorType: "/api/Sensor/SensorType",
        GetStaffInfByJob: "/api/sensor/GetStaffInfByJob",
        GetStaffAllocatedVehicle: "/api/staff/GetStaffAllocatedVehicle",
        GetSensorLocal: '/api/Sensor/GetSensorLocal',
        SaveOrderWithCustomer: '/api/order/SaveOrderWithCustomer',
        SaveSingleOrderWithCustomer: '/api/order/SaveSingleOrderWithCustomer',
        GetOrderHistory: '/api/order/GetOrderHistory/',
        GetEditedOrderDetails: '/api/order/GetEditedOrderDetails/',
        GetCustomer: '/api/NormaCustomer/GetCustomer/',
        GetPickup: '/api/NormaCustomer/GetPickup/',
        deleteStaffById: "/api/staff/SetStaffOfflineAndFreeVehicle/",
        GetOnlineStaffCount: "/api/staff/GetOnlineStaffCount",
        GetFreeVehiclesCount: "/api/WO/GetFreeVehiclesCount",
        GetFreeVehiclesDetails: "/api/WO/GetFreeVehiclesDetails",

        //order
        orderApi:"/api/order/",
        GetSlaAlertOrdersCounts: "/api/order/GetSlaAlertOrdersCounts",
        orderListSearchUrl: '/api/order/search',
        GetAllOrderStatusUrl: '/api/order/GetAllOrderStatus',
        orderListSearchByOrderCodeUrl: '/api/order/SearchByOrderCode',
        orderListSearchByWorkorderIdeUrl: '/api/order/SearchByWorkorderId',
        GetCountDownData: '/api/order/GetCountDownData',
        GetSalesIdOfCurrentUser: '/api/order/GetSalesIdOfCurrentUser',


        addNewOrder: "/api/order/add",
        orderDetails: "/api/order/GetOrderSorting",
        GetRescheduleDate: "/api/order/GetRescheduleDate",
        GetProductsByOrderCode: '/api/Order/GetProductsByOrderCode/',
        GetOrderDetailsWithCustomerByOrderCode: '/api/Order/GetOrderDetailsWithCustomerByOrderCode/',
        ValidatePendingOrder:'/api/Order/ValidatePendingOrder/',
        // package
        UpdateProductPrintCountByNumber: '/api/Package/UpdateProductPrintCountByNumber',
        UpdateProductStatusForAdmin: '/api/NormaProduct/UpdateProductStatusForAdmin',

        //Zone
        getInfluencedZones: "/api/Zone/GetZonesInf",
        UpdateOrdersStatusAtVuloIntegration: '/api/order/UpdatVuloOrderStatus',
        GetWorkorderActualAmount: '/api/WO/GetWorkorderActualAmount/',
        ExportWorkOrderRunSheet: '/api/WO/ExportWorkOrderRunSheet/',
        GetZonesByCityId: "/api/Zone/GetZonesByCities",
        GetZonesByCitiesAddOrEditNewOrder:"/api/Zone/GetZonesByCitiesAddOrEditNewOrder",
        GetZoneByIdEditOrder: "/api/Zone/GetZoneByIdEditOrder",
        //TechincalSupport
        changeOrderStatus:"/api/TechnicalSupport/ChangeOrderStatus"
    },

    modulePrefixes: {
        accountManagement: 'users',
        administration: 'administration',
        analytics: 'analytics',
        operations: 'operations',
        resourceManagement: 'resources',
        trackingAndMonitoring: 'tracking',
        reportsAndLogs: 'reportlog',
        devices: 'devices',
        subscriberUsers: 'subscriberusers',
        adminLanding: 'adminlanding',
        maintenance: 'maintenance',
        techincalSupport: 'techincalsupport'
    },

    pages: {
        listvehicles: 'vehicles_management',
        editVehicles: 'vehicles_edit',
        listusers: 'users_management',
        editUsers: 'users_edit',
        poi: 'pois_management',
        geofence: 'geofences_management',
        branches: 'branches',
        history: 'history',
        livetrack: 'live_tracking',
        livemonitor: 'live_monitoring',
        detailedreports: 'detailed_report',
        aggregatedreports: 'aggregated_reprort',
        dashboard: 'dashboard',
        welcome: 'admin_landing',
        // outliersdashboard: 'outliers_dashboard',
        // overalldashboard: 'overall_dashboard',
        // violationdashboard: 'violation_dashboard',
        subscriberlist: 'subscribers_management',
        subscriberSettings: 'subscriber_settings',
        organization: 'organization_chart',
        roles: 'roles-management',
        permittedbranches: 'permitted_branches_management',
        devicelist: 'devices_management',

        staticReports: 'static_reports',
        operationalreports: 'operational_reports',

        branchAllocation: 'branch-allocation',
        normaorderslist: 'order_list',
        drivercapacitydashboard:"driver_capacity_dashboard",
        ordersrawdatareport: 'ordersrawdatareport',
        resourceAllocation: {
            branch: {
                home: "branch-allocation",
                staff: 'allocate-staff',
                vehicle: 'allocate-vehicle',
                equipment: 'allocate-equipment',
            },
            resourcesAllocation: {
                home: "resource-allocation",
                staff: "staff",
                equipment: "equipment",
                vehicle: "vehicle",
                allocatestaff: 'allocate-staff',
                allocatevehicle: 'allocate-vehicle',
                allocateequipment: 'allocate-equipment',
            },
            workOrder: {
                list: 'workorder_list',
                reallocate: 'workorder_reallocation',
                wizard: "manual_workorder",
            },
        },
        orderreceiving: 'order_receiving',
        orderReturnsConfirmation: 'orderReturnsConfirmation',


        // report and log
        poilog: 'poi_log',
        geofencelog: 'geofence_log',
        packetslog: 'packet_log',
        vehicleslog: 'vehicle_log',
        stafflog: 'staff_log',
        vehiclessummary: 'vehicle_summary',
        firstsignalreport: 'first_signal',
        subscribersummaryreport: 'subscriber_summary',
        usersummaryreport: 'user_summary',
        smslog: 'smslog',
        gpsdisconnected: 'gpsdisconnected',

        // devices
        deviceslist: 'device_list',
        devicelog: 'device_log',
        adddevice: 'adddevice',
        // Subscriber users
        unlockusers: 'unlock_users',

        // maintenance
        pmlist: 'pm_list',
        repairsList: 'repairs_list',
        rfrdetails: 'rfr_details',
        addnewpmp: 'pmp',
        addnewmwo: 'maintenance_workorder',

        //technicalsupport
        technicalsupport: 'technical_support',
        changeorderstatus: 'changeorderstatus'
    },

    keys: {
        googleApiKey: 'AIzaSyAAWPYbQpoNYv_BgSCknDfi-i-d1lznt8U',
        //planning service Keys
        LogisticsServiceToken: 'IBrkRtJb3z6Bp2sEGCAVIQBfZPCRGwhDxvMqMS1RtVnzz0O356IMaSekOQDjQ9WGHo-MUCYanlkLgieO8ePONcmytud7N553mfvSU-CjAdc0gIzEZm3uBKtVNjgE7wPdio0ptHLYrL9aIB-WKWmdIg..',
        LogisticsServiceTimeUnits: 'Minutes',
        LogisticsServiceDistanceUnits: 'Kilometers',
        LogisticsServiceUturnPolicy: 'NO_UTURNS',
        LogisticsServicePopulateDirections: "true",
        LogisticsServiceDirectionsLanguage: "en",
    },

    messages: {
        defaultErrorMessage: 'unexpectedErrorMessage',
        usernameErrorMessage: 'USER_ALREADY_EXIST',
        emailErrorMessage: 'EMAIL_ALREADY_EXIST',
        mobileErrorMessage: 'MOBILE_ALREADY_EXIST',
        CodeErrorMessage: 'Code_ALREADY_EXIST',
        invalidInput: 'INPUT_INVALID',
        invalidPasswordFormat: 'validation_invalidPassword',
        incorrectPassword: 'validation_incorrectPassword',
        transporterPlateExist: 'PLATE_ALREADY_EXIST',
        transporterCodeExist: 'TRANSPORTER_CODE_EXIST',
        transporterAssigned: 'TRANSPORTER_ALREADY_ASSIGNED',
        emailNotFound: 'EMAIL_NOT_FOUND',
        emailSent: 'EMAIL_SENT',
        branchCodeExist: 'BRANCH_CODE_EXIST',
        studentRFIDExist: 'STUDENT_RFID_EXIST',
        domainExist: 'SUBSCRIBER_Domain_EXIST',
        staffEmailExist: 'EMAIL_ALREADY_EXIST',
        organizationHasChildren: 'Organization_HAS_CHILDREN',
        organizationHasStaff: 'Organization_HAS_Staff',
        deviceCodeExist: 'DEVICE_CODE_EXIST',
        SIMCareExist: 'DEVICE_SIM_EXIST',
        RuleExist: 'RULE_ALREADY_EXIST',
        CodeExist: 'ALREADY_EXIST',
        sensorPlateExist: 'PORT_Number_Duplicated',
        PortTypeCustomDuplicate: 'PortTypeCustomDuplicate',
    },

    paths: {
        liveTrackUrl: '/tracking',

        userListUrl: '/resources/userlist',
        userDetailsUrl: '/resources/userdetails',
        transporterListUrl: '/resources/transporterlist',
        trapsorterDetailsUrl: '/resources/transporterdetails',

        loginUrl: '/users/login',
        changePassword: '/users/changepassword',
        logout: '/users/logout',
        deviceListUrl: '/users/devicelist',
        deviceDetailsUrl: '/users/devicedetails',
        resetPasswordUrl: '/users/resetpassword',
        notificationSettings: '/users/notificationssettings',

        pageNotFoundUrl: '/pagenotfound',
        unauthorizePage: '/unauthorize',
    },

    mapSettings: {

        defaultZoomLevel: 10,
        defaultLatitude: 24.760580,
        defaultLongitude: 46.727319,

        //Esri Settings
        esriBaseMap: 'streets',
        esriSpatialReference: 4326,

        //google settings
        zoomControl: true,
        mapTypeControl: true,
        MapTypeControlStyle: "HORIZONTAL_BAR", //DROPDOWN_MENU ,DEFAULT,HORIZONTAL_BAR
        mapTypeIds: ['roadmap', 'terrain', 'satellite', 'hybrid'],
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        geoLocation: false,
        geoLocationIcon: true,

        objectsZoomThreshold: 10
    },

    resources: {
        sharedResourceName: 'shared'
    },

    patterns: {
        latitude: "/[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)/",
        longitude: "/[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)/"
    },

    gisRoutingSettings: {
        nearestBuffer: 1000,
        numberofPoints: 3,
        busStopId: 1,
        boatStopId: 2
    },

    deviceStyle: {
        styleSheetName: 'altair-icons.css'
    },

    demo: {
        proxyUrl: 'http://localhost:81/Demos/proxy/proxy.ashx'
    },

    utilities: {
        // fakePassword: 'P@ssw0rd01'
    },

    tokens: {
        GoogleMapDirectionsToken: 'AIzaSyB_HWxIIAw5vdXy4zgFh3KKEj6BAc9MWI4'
    },

    defaultMapParams: {
        zoom: 10,
        mapType: 'google',
        centerX: 31.259443,
        centerY: 30.099036,
        minZoom: 5,
        maxZoom: 20
    },

    defaultConfigurations: {
        vehiclesLimit: 5,
        usersLimit: 1,
        geofenceLimit: 5,
        poiLimit: 5
    },

    allowedTypes: "jpg,gif,png",
    maxFileSize: 4194304,
    maxFileNameLength: 250,
    type: 'POIImg',
    //intervalTimerToGetOrderList number by millisecond
    //second = 1000 millisecond
    intervalTimerToGetOrderList: 15000,

    reference: {
        driver: 20,
        parent: 6,
    },

    modulesPagesGraph: [
        {
            'key': 'accountManagement', 'value': 'users', 'url': '',
            'page': []
        }
        ,
        {
            'key': 'administration', 'value': 'administration', 'url': '/administration',
            'page': [
                { 'key': 'organization', 'value': 'organization_chart', 'url': '/organization' },
                { 'key': 'subscriberlist', 'value': 'subscribers_management', 'url': '/subscriberlist' },
                { 'key': 'devicelist', 'value': 'subscribers_management', 'url': '/subscriberlist' },
                { 'key': 'roles', 'value': 'roles-management', 'url': '/roles' },
                { 'key': 'subscriberSettings', 'value': 'subscriber_settings', 'url': '/subscribersettings' },
            ]
        }
        ,
        {
            'key': 'analytics', 'value': 'analytics', 'url': '/analytics',
            'page': [
                { 'key': 'detailedreports', 'value': 'detailed_report', 'url': '' },
                { 'key': 'aggregatedreports', 'value': 'aggregated_reprort', 'url': '/aggregated' },
                { 'key': 'overalldashboard', 'value': 'overall_dashboard', 'url': '/overalldashboard' },
                { 'key': 'violationdashboard', 'value': 'violation_dashboard', 'url': '/violationdashboard' },
                { 'key': 'outliersdashboard', 'value': 'outliers_dashboard', 'url': '/outliersdashboard' },
            ]
        }
        ,
        {
            'key': 'operations', 'value': 'operations', 'url': '/operations',
            'page': [
                { 'key': 'resourceAllocation.branch.home', 'value': 'detailed_report', 'url': '/branch-allocation' },
                { 'key': 'resourceAllocation.resourcesAllocation.home', 'value': 'aggregated_reprort', 'url': '/resource-allocation' },
                { 'key': 'workOrder.list', 'value': 'workorder_list', 'url': '/workorder' },
                { 'key': 'workOrder.reallocate', 'value': 'workorder_reallocation', 'url': '/workorder-reallocation' },
                { 'key': 'workOrder.wizard', 'value': 'manual_workorder', 'url': '/workorderwizard' },
                { 'key': 'normaorderslist', 'value': 'order_list', 'url': '/normaorderslist' },


            ]
        }
        ,
        {
            'key': 'resourceManagement', 'value': 'resources', 'url': '/resources',
            'page': [
                { 'key': 'listusers', 'value': 'users_management', 'url': '/userlist' },
                { 'key': 'listvehicles', 'value': 'vehicles_management', 'url': '/transporterlist' },
                { 'key': 'poi', 'value': 'pois_management', 'url': '/poi' },
                { 'key': 'geofence', 'value': 'geofences_management', 'url': '/geofence' },
                { 'key': 'branches', 'value': 'branches', 'url': '/branches' },

            ]
        }
        ,
        {
            'key': 'trackingAndMonitoring', 'value': 'tracking', 'url': '/tracking',
            'page': [
                { 'key': 'livetrack', 'value': 'live_tracking', 'url': '/live' },
                { 'key': 'livemonitor', 'value': 'live_monitoring', 'url': '/monitor' },
                { 'key': 'history', 'value': 'history', 'url': '/history' },
                { 'key': 'speedreport', 'value': 'speed-temperature-report', 'url': '/speedreport/:id' },
                { 'key': 'temperaturereport', 'value': 'speed-temperature-report', 'url': '/temperaturereport/:id' },
                { 'key': 'eventsensorreport', 'value': 'event-sensor', 'url': '/eventsensorreport/:id' },
                { 'key': 'analogsensorreport', 'value': 'analog-canbus-report', 'url': '/analogsensorreport/:id' },
                { 'key': 'canbussensorreport', 'value': 'sanalog-canbus-report', 'url': '/canbussensorreport/:id' },
            ]
        },
        {
            'key': 'adminLanding', 'value': 'adminlanding', 'url': '/adminlanding',
            'page': [
                { 'key': 'welcome', 'value': 'admin_landing', 'url': '/welcome' }
            ]
        },



        {
            'key': 'subscriberUsers', 'value': 'subscriberusers', 'url': '/subscriberusers',
            'page': [
                { 'key': 'unlockusers', 'value': 'unlock_users', 'url': '/unlockusers' }
            ]
        },

        {
            'key': 'maintenance', 'value': 'maintenance', 'url': '/maintenance',
            'page': [

                { 'key': 'addnewpmp', 'value': 'pmp', 'url': '/addnewpmp/:id' },
                { 'key': 'pmlist', 'value': 'pm_list', 'url': '/pmlist' },
                { 'key': 'addnewmwo', 'value': 'maintenance_workorder', 'url': '/addnewmwo' },
                { 'key': 'repairslist', 'value': 'repairs_list', 'url': '/repairslist' },
                { 'key': 'rfrdetails', 'value': 'rfr_details', 'url': '/rfrdetails/:id' },

            ]
        },

    ]
    , egyptpostCustomSubscriberId: 40160
    , ShiftWorkOrdertimeInMinutes:15
};




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/configurations/shared.config.ts